<template>
  <div class="container-confirm">
    <van-dialog v-model="showDiaC" :showConfirmButton="false" :closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <div class="headline" v-if="headline">{{ headline }}</div>
        <div class="title" v-if="title">{{ title }}</div>
        <div class="btn">
          <div v-if="oneShow" class="one" @click="handleGot">{{ $t('lang.BaseCommon.k039') }}</div>
          <div v-else class="two">
            <span @click="handleThinK" class="confirm-think">{{ $t('lang.BaseCommon.k098') }}</span>
            <span @click="handleConfirm" class="confirm-btn">{{ $t('lang.BaseCommon.k028') }}</span>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showDiaC: {
      type: Boolean,
      default: false,
    },
    title: {},
    headline: {},
    oneShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    handleGot() {
      this.close()
    },
    handleThinK() {
      this.$parent.thinKCon()
    },
    handleConfirm() {
      this.$parent.confirmCon()
    },
    close() {
      this.$parent.cancelAgain()
    },
  },
}
</script>
<style lang="scss" scoped>
.container-confirm {
  .dialog {
    width: 300px;
    // height: 172px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 20px 20px 20px;
    margin: 0 auto;
    .headline {
      width: 100%;
      text-align: center;
      color: #000;
      font-weight: 600;
    }
    .title {
      // width: 260px;
      // height: 40px;
      font-size: 16px;
      font-family: 'Inter-Medium', 'Inter-Regular';
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      text-align: center;
      margin: 10px 0;
    }
    .one {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin: 20px auto 0;
      background: #a338fc;
      border-radius: 20px;
      font-size: 16px;
      font-family: 'Inter-Bold', 'Inter-Regular';
      font-weight: 600;
      color: #ffffff;
    }
    .two {
      display: flex;
      align-items: center;
      justify-content: space-around;
      > span {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 10px auto 0;
        background: #a338fc;
        border-radius: 20px;
        font-size: 16px;
        font-family: 'Inter-Bold', 'Inter-Regular';
        font-weight: 600;
        color: #ffffff;
      }
      .confirm-think {
        background-color: #e1e1e1;
      }
    }
  }
}
</style>
